import { render, staticRenderFns } from "./ActivityListScreen.vue?vue&type=template&id=c8f35e60&"
import script from "./ActivityListScreen.vue?vue&type=script&lang=js&"
export * from "./ActivityListScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports